import  { useMemo, useState, useEffect } from "react";
import styles from "./ProjectsPanel.module.css";
import commonStyle from "../common.module.css";
import Topbar from "../../Components/TopBar/TopBar";
import { PROJECT_COLUMNS, ProjectColumnsMaster } from "../../Values/tables";
import { useTable, useSortBy, useFilters, useColumnOrder } from "react-table";
import TableHeader from "../../Components/TableHeader/TableHeader";
import {deleteProject, fetchProjects, fetchProjectsMaster } from "../../Services/contacts";
import ImportContactsModal from "../../Components/Modals/ImportModal/ImportContactsModal";
import { connect, useDispatch } from "react-redux";
import {
  getFilterObject,
  filterProjectStatus,
  searchProjectItem,
} from "../../Values/utils";
import Loading from "../../Components/Loading/Loading";
import ColumnManagerModal from "../../Components/Modals/ColumnManagerModal/ColumnManager";
import { MdDelete } from "react-icons/md";
import { FiEdit3 } from "react-icons/fi";
import ApiTopBar from "../../Components/TopBar/ApiTopBar";
import ApiCustomTable from "../../Components/CustomTable/ApiCustomTable";
import DeleteSelectedModal from "../../Components/Modals/DeleteSelectedModal/DeleteSelectedModal";
import DeleteProjectSelectedModal from "../../Components/Modals/DeleteSelectedModal/DeleteProjectSelectedModal";
import { themeColors } from "../../Components/theme";
import CustomTable from "../../Components/CustomTable/CustomTable";
import ProjectCustomTable from "../../Components/CustomTable/ProjectCustomTable";
import { useMediaQuery } from "@material-ui/core";
import ImportMasterProjectModal from "../../Components/Modals/ImportModal/ImportMasterProjectModal";
import { projectHeader } from "../../Values/masterHeader";
import DeleteMasterProjectSelectedModal from "../../Components/Modals/DeleteSelectedModal/DeleteMasterProjectSelectedModal";
import { showSnackbarAction } from "../../Redux/actions";
import { downloadCSVMatser, exportMasterData } from "../../Services/organizations";

const ProjectsPanelReplicateAdmin = ({ history, user, organizationUsers, theme, searchString }: any) => {
  const isMobile = useMediaQuery('(max-width: 900px)');
  const dispatcher = useDispatch();
  const [projectsList, setProjectsList] = useState<any[] | undefined>(
    undefined
  );
  const [tasksImportModal, setTasksImportModal] = useState(false);
  const [notesImportModal, setNotesImportModal] = useState(false);
  const [callLogsImportModal, setCallLogsImportModal] = useState(false);
  const [lastPage, setLastPage] = useState(-1);
  const [totalCounts, setTotalCounts] = useState<any>();
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(100);
  const [searchedItem, setsearchedItem] = useState("");
  const [selectedRowsData, setSelectedRowsData] = useState<any[]>([]);
  const [filterData, setFilterData] = useState<any[] | undefined>(undefined);
  const [temporaryData, setTemporaryData] = useState<any[]>([]);
  const [searchQuery, setsearchQuery] = useState("");
  const [status, setStatus] = useState("ALL");
  const [columnModal, setColumnModal] = useState(false);
  const [selectedRows, setSelectedRows] = useState<any[]>([]);
  const [showImportModal, setShowImportModal] = useState(false);
  const [load, setLoad] = useState(false);
  const [owner, setOwner] = useState(false);
  const [deletePopup, setDeletePopop] = useState(false);
  const [clearFilterTable, setClearFilterTable] = useState(false);

  useEffect(() => {
    const unsub = fetchProjectsMaster(
      (data) => setProjectsList(data),
    );
    return () => {
      unsub();
    };
  }, []);

  useEffect(() => {
    if (projectsList !== undefined) {
      setFilterData(projectsList);
    }
  }, [projectsList, dispatcher]);

  useEffect(() => {
    if (status === "ALL") {
      if (projectsList) {
        const data = searchProjectItem(projectsList, searchedItem);
        setTemporaryData(data);
        setFilterData(data);
      }
    } else {
      const data = searchProjectItem(temporaryData, searchedItem);
      setFilterData(data);
    }
    // eslint-disable-next-line
  }, [searchedItem, projectsList]);

  useEffect(() => {
    if (searchedItem === "") {
      if (projectsList) {
        const data = filterProjectStatus(projectsList, status);
        setTemporaryData(data);
        setFilterData(data);
        setTotalCounts(data.length);
      }
    } else {
      const data = filterProjectStatus(temporaryData, status);
      setFilterData(data);
    }
    // eslint-disable-next-line
  }, [status, projectsList]);

  useEffect(() => {
    if (selectedRows.length > 0) {
      setOwner(true);
    } else if (selectedRows.length === 0) {
      setOwner(false);
    }
  }, [selectedRows]);

  const selectAll = (checked: boolean) => {
    if (checked === true) {
      setSelectedRows(Array.from(Array(filterData?.length).keys()));
    } else {
      setSelectedRows([]);
    }
  };

  const columns = useMemo(() => PROJECT_COLUMNS, []);
  const data = useMemo(() => (filterData ? filterData : []), [filterData]);

  const tableInstance: any = useTable(
    {
      columns,
      data,
    },
    useFilters,
    useSortBy,
    useColumnOrder
  );

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    rows,
    prepareRow,
    allColumns,
    setColumnOrder,
    toggleHideAllColumns,
    setAllFilters,
  } = tableInstance;

  useEffect(() => {
    if (filterData) {
      getFilterObject(filterData, dispatcher);
    }
  }, [filterData, dispatcher]);

  const clearSort = () => {
    headerGroups[0].headers.forEach((header: any) => {
      header.clearSortBy();
    });
  };
  const clearSelectedRowsData = () => {
    setSelectedRowsData([]);
    setSelectedRows([]);
  };

 const exportFile = () => {
     if (!selectedRowsData?.length) {
       dispatcher(showSnackbarAction("No rows selected!", "error"));
       return;
     }
     const exportData = exportMasterData(selectedRowsData, ProjectColumnsMaster(projectHeader));
     if (!exportData.length) {
       dispatcher(showSnackbarAction("No data available for export!", "error"));
       return;
     }
     downloadCSVMatser(exportData, "ContactsExport");
     dispatcher(showSnackbarAction("Exported successfully!", "success"));
   };

  const handleClearFilter = () => {
    setClearFilterTable(prev => !prev);
  };
  
  const containerStyles = { backgroundColor: theme ? themeColors.backgroundColor : themeColors.backgroundColorDark, color: theme ? themeColors.textPrimary : themeColors.textPrimaryDark };
  return (
    <>
      <div className={styles.parent} style={{ display: "block", marginTop: isMobile ? "6%" : "4%", ...containerStyles }}>
        {(projectsList === undefined || load === true) && <Loading />}
        <div className={commonStyle.topBar} style={{ marginTop: "0px", ...containerStyles }}>
          <ApiTopBar
            history={history}
            title={"Add Project"}
            path={"/addProjects"}
            owner={owner}
            deleteSelected={() => {
              setDeletePopop(true);
            }}
            onClick={() => {
              setShowImportModal(true);
            }}
            onChange={(val) => setsearchedItem(val)}
            filterText={"Status"}
            setColumnModal={(data) => setColumnModal(data)}
            show={true}
            showStatusBox={true}
            onExport={exportFile}
            onCallLogsImport={() => {
              setCallLogsImportModal(true);
            }}
            onNotesImport={() => {
              setNotesImportModal(true);
            }}
            onTasksImport={() => {
              setTasksImportModal(true);
            }}
            searchedString={searchString}
            clearFilter={handleClearFilter}
            role="Replicate"
          />
        </div>
        <div className={commonStyle.parentp} style={{ minHeight: "450px", ...containerStyles }}>
          <ProjectCustomTable
            tableColumns={ProjectColumnsMaster(projectHeader)}
            tableRows={filterData}
            selectedRows={selectedRows}
            setSelectedRows={(data) => setSelectedRows(data)}
            tableType="API"
            showColumnModal={columnModal}
            hideColumnModal={() => setColumnModal(false)}
            selectedRowsData={selectedRowsData}
            setSelectedRowsData={(data) => setSelectedRowsData(data)}
            setSearchedItem={(val) => setsearchQuery(val)}
            clearFilterTable={clearFilterTable}
          />
        </div>
        {showImportModal && (
          <ImportMasterProjectModal
            open={showImportModal}
            close={() => setShowImportModal(false)}
            history={history}
            usersList={organizationUsers}
            user={user}
          />
        )}
        {deletePopup && (
          <DeleteMasterProjectSelectedModal
            data={selectedRowsData}
            clearSelectedRowsData={clearSelectedRowsData}
            open={deletePopup}
            totalData={projectsList}
            close={() => {
              setDeletePopop(false);
            }}
          />
        )}
      </div>
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    organizationUsers: state.organizationUsers.data,
    theme: state.theme.isLightMode,
    searchString: state.searchItem.projectSearchString,
  };
};

export default connect(mapStateToProps)(ProjectsPanelReplicateAdmin);